// ============================================================
// viewingPane.constants.ts
// Configuration for all viewing pane headings and toggles
// ============================================================
import { ViewingPaneHeading } from '../types/case.types'
export interface HeadingConfig {
  key: ViewingPaneHeading
  label: string
  adminOnly: boolean
  defaultVisible: boolean
}
export const VIEWING_PANE_HEADINGS: HeadingConfig[] = [
  { key: 'automatic',       label: 'Automatic',        adminOnly: false, defaultVisible: true  },
  { key: 'history',         label: 'History',          adminOnly: false, defaultVisible: true  },
  // Stage 4 — the case's billable Activity feed (ClientActivityFeed scoped
  // to the case). Not in the setup chain.
  { key: 'activity',        label: 'Activity',         adminOnly: false, defaultVisible: true  },
  { key: 'clientSource',    label: 'Client Source',    adminOnly: false, defaultVisible: true  },
  { key: 'clientDetails',   label: 'Client Details',   adminOnly: false, defaultVisible: true  },
  { key: 'accidentDetails', label: 'Accident Details', adminOnly: false, defaultVisible: true  },
  { key: 'injuryDetails',   label: 'Injury Details',   adminOnly: false, defaultVisible: true  },
  { key: 'witnesses',       label: 'Witnesses',        adminOnly: false, defaultVisible: true  },
  { key: 'defendant',       label: 'Defendant',        adminOnly: false, defaultVisible: true  },
  { key: 'tpi',             label: 'TPI',              adminOnly: false, defaultVisible: true  },
  { key: 'linkedCases',     label: 'Linked Cases',     adminOnly: false, defaultVisible: false },
  { key: 'medicalAgency',   label: 'Medical Agency',   adminOnly: false, defaultVisible: false },
  { key: 'medicalExpert',   label: 'Medical Expert',   adminOnly: false, defaultVisible: false },
  { key: 'tps',             label: 'TPS',              adminOnly: false, defaultVisible: false },
  { key: 'documents',       label: 'Documents',        adminOnly: false, defaultVisible: true  },
  { key: 'deadlines',       label: 'Deadlines',        adminOnly: false, defaultVisible: true  },
  { key: 'funding',         label: 'Funding',          adminOnly: false, defaultVisible: true  },
  // Invoicing Stage 1 — bills + WIP + disbursements for the case. Not in the
  // setup chain. Bills need billing access (server-enforced); without it the
  // section shows disbursements only.
  { key: 'billing',         label: 'Billing',          adminOnly: false, defaultVisible: true  },
  // Stage 4 round 2a — the CFA, settlement inputs and the live deductions
  // preview. Not in the setup chain. Needs "See colleagues' billing" (or
  // admin) to show figures — server-enforced; others see a locked card.
  { key: 'settlement',      label: 'Settlement',       adminOnly: false, defaultVisible: true  },
  // Settings is an unbuilt placeholder (SettingsSection renders only a
  // "coming soon" line). Hidden from the case-detail nav for now by NOT
  // listing it here — VIEWING_PANE_HEADINGS is the single source the nav
  // filter (ViewingPane.tsx:122), the toggle panel (HeadingTogglePanel),
  // and the per-user toggle defaults (useCasevoStore.ts:592) all iterate,
  // so omitting it removes it everywhere. SettingsSection.tsx + the
  // ViewingPane SECTION_MAP entry stay on disk (just never reached), and
  // 'settings' is NOT in COMPLETABLE_SECTIONS, so completion counts and the
  // sequential flow are unaffected. Re-enable by uncommenting this line.
  // { key: 'settings',        label: 'Settings',         adminOnly: true,  defaultVisible: false },
]
